module.exports = __webpack_public_path__ + "static/media/prayer-timetable.b95a72c5.jpeg";